import { Observable } from 'rxjs';
import { Response } from './response';
import { HttpHeaders } from '@angular/common/http';
import shellapi from 'a365-shell-api';

export enum ResponseContentType {
    Text = 0,
    Json = 1,
    ArrayBuffer = 2,
    Blob = 3
}

export enum ResponseType {
    Basic,
    Cors,
    Default,
    Error,
    Opaque
}

export enum ResponseTypeNames {
    JSON = 'json',
    ARRAYBUFFER = 'arraybuffer',
    TEXT = 'text',
    BLOB = 'blob'
}

export enum RequestMethod {
    Get = 0,
    Post = 1,
    Put = 2,
    Delete = 3,
    Options = 4,
    Head = 5,
    Patch = 6
}

export interface IResponseOptionsArgs {
    body?: string | object | FormData | ArrayBuffer | Blob | null;
    status?: number | null;
    statusText?: string | null;
    headers?: shellapi.http.IHeaders | null;
    // eslint-disable-next-line
    type?: ResponseType | null;
    url?: string | null;
}

export interface IHttp {
    request(url: string, options?: IRequestOptionsArgs): Observable<Response>;

    get(url: string, options?: IRequestOptionsArgs): Observable<Response>;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    post(url: string, body: any, options?: IRequestOptionsArgs): Observable<Response>;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    put(url: string, body: any, options?: IRequestOptionsArgs): Observable<Response>;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    delete(url: string, options?: IRequestOptionsArgs): Observable<Response>;
}

export interface IRequestOptionsArgs {
    url?: string | null;
    method?: string | RequestMethod | null;
    params?: {
        [param: string]: string | string[];
    };
    headers?: shellapi.http.IHeaders | null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    body?: any;
    withCredentials?: boolean | null;
    responseType?: ResponseContentType | shellapi.http.ResponseContentType | null;
}

export interface IRequestOptionsBase {
    headers?: HttpHeaders | {
        [header: string]: string | string[];
    };
    observe: 'response';
    params?: {
        [param: string]: string | string[];
    };
    reportProgress?: boolean;
    responseType: 'text' | 'json' | 'blob' | 'arraybuffer';
    withCredentials?: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    body?: any;
}

export interface IRequestOptionsText extends IRequestOptionsBase {
    responseType: 'text';
}

export interface IRequestOptionsJson extends IRequestOptionsBase {
    responseType: 'json';
}

export interface IRequestOptionsBlob extends IRequestOptionsBase {
    responseType: 'blob';
}

export interface IRequestOptionsArrayBuffer extends IRequestOptionsBase {
    responseType: 'arraybuffer';
}
